<script>
export default {
  props: {
    back: { type: Boolean, default: true }, //是否显示返回
    paths: { type: Array, required: true, default: () => [] } //导航路径
  },

  methods: {
    //返回上一页
    onBack() {
      if(this.back && window.history.length > 1) {
        this.$router.back()
      }
    }
  }
}
</script>

<template>
  <div class="crumb">
    <!--左侧面包屑-->
    <el-page-header :class="[back ? '' : 'no-back']" @back="onBack">
      <div slot="content" class="crumb-content">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item, index) in paths" :key="index" :to="item.path ? { path: item.path } : null">{{ item.name || item }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </el-page-header>

    <!--右侧扩展-->
    <div class="crumb-extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<style lang="scss">
.crumb{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-page-header{
    .el-page-header__left{
      margin-right: 15px;

      &::after{
        right: -5px;
      }

      .el-page-header__title{
        display: none;
      }
    }

    &.no-back{
      .el-page-header__left{
        display: none;
      }
    }
  }

  &-content{
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
